import { Dropdown } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContractType } from '../../../../../common/types'
import { resolveContractTerminationTerminology } from '../../utils/resolveContractTerminationTerminology'

import FormFieldWrapper from 'components/FormField'
import { FormFieldInfoTooltip } from 'components/FormFieldInfoTooltip/FormFieldInfoTooltip'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'
import { useContractTerminationReasons } from 'views/TerminateContract/hooks/useContractTerminationReasons'

interface TerminationReasonFieldProps {
  contractType: ContractType
}

export const TerminationReasonField: React.FC<TerminationReasonFieldProps> = ({
  contractType,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const { contractTerminationReasons } = useContractTerminationReasons()
  const terminology = resolveContractTerminationTerminology(contractType)

  return (
    <Field name="terminationReason">
      {({ field, meta, form }: FieldProps<FormValues['terminationReason']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t(terminology.reasonLabel)}
          className="min-tablet:max-w-96 mt-8"
          meta={meta}
          required
          labelBold
          labelAddon={
            <FormFieldInfoTooltip
              text={t('terminateContract:texts.terminationReasonTooltip')}
            />
          }
        >
          <Dropdown
            id={field.name}
            options={contractTerminationReasons}
            placeholder={t('common:placeholders.select')}
            onChange={(option) =>
              form.setFieldValue(field.name, option ? option.id : '')
            }
            value={contractTerminationReasons.find(
              (option) => option.id === meta.value
            )}
            allowEmpty
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
